const GA_ID = import.meta.env.VITE_GA_ID;

export function logEvent(name: string, params?: Record<string, any>) {
    if (!GA_ID || !window.gtag) return;
    window.gtag("event", name, params);
}

// ─── GA4 e-commerce helpers ──────────────────────────────────────────────────
// Centralises the GA4 `items[]` shape so every funnel event is consistent.
// Consent Mode (see analytics.ts) gates whether these are actually collected.

export type GAItem = {
    item_id: string;
    item_name: string;
    item_category?: string;
    price?: number;
    quantity?: number;
};

export function trackViewItem(p: {
    eventId: string;
    eventName: string;
    category?: string;
    currency?: string;
}) {
    logEvent("view_item", {
        currency: p.currency,
        items: [{item_id: p.eventId, item_name: p.eventName, item_category: p.category}],
    });
}

export function trackAddToCart(p: {item: GAItem; currency?: string; value?: number}) {
    logEvent("add_to_cart", {
        currency: p.currency,
        value: p.value,
        items: [p.item],
    });
}

export function trackRemoveFromCart(p: {item: GAItem; currency?: string; value?: number}) {
    logEvent("remove_from_cart", {
        currency: p.currency,
        value: p.value,
        items: [p.item],
    });
}

export function trackBeginCheckout(p: {items: GAItem[]; value: number; currency?: string}) {
    logEvent("begin_checkout", {
        currency: p.currency,
        value: p.value,
        items: p.items,
    });
}

export function trackPurchase(p: {
    transactionId: string;
    value: number;
    currency?: string;
    items?: GAItem[];
}) {
    logEvent("purchase", {
        transaction_id: p.transactionId,
        value: p.value,
        currency: p.currency,
        items: p.items ?? [],
    });
}
